import { render, staticRenderFns } from "./TaskDashboard.vue?vue&type=template&id=8483d782&scoped=true"
import script from "./TaskDashboard.vue?vue&type=script&lang=js"
export * from "./TaskDashboard.vue?vue&type=script&lang=js"
import style0 from "./TaskDashboard.vue?vue&type=style&index=0&id=8483d782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8483d782",
  null
  
)

export default component.exports